import ModelUtil from '@leverege/model-util';
import { ns } from '@leverege/i18n';
import Curves from "./Curves.js";
const TYPE = 'graph.series.area';
const {
  t
} = ns('ui-attributes-graphs.models.AreaSeriesModel');
function create(extend) {
  return {
    type: TYPE,
    get name() {
      return t('name');
    },
    fillOpacity: 0.4,
    curve: 'linear',
    ...extend
  };
}
const base = {
  ...ModelUtil.createAllValue('fillOpacity'),
  ...ModelUtil.createAllValue('curve')
};
export default {
  create,
  TYPE,
  get name() {
    return t('name');
  },
  type: TYPE,
  getSeriesProps: model => {
    return {
      fillOpacity: base.getFillOpacity(model),
      get curve() {
        return Curves[model.curve] || Curves.linear;
      }
    };
  },
  ...base
};